import { io } from 'socket.io-client';

const URL = process.env.REACT_APP_CONTENT_FEED_API ?? '';

export const socket = io(URL, {
  withCredentials: true,
  transports: ["websocket"]
});
